import React from 'react'
import Container from '../../Container/Container'

function AddPromOrder() {
    return (
        <Container>
            <div class="nk-content ">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">Add Prom Order</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="card card-full">
                                <div class="card-inner">
                                    <div class="stepperLeft">
                                        <div className="row">
                                            <div className="col-md-4 brIght">
                                                <section class="section1">
                                                    <header>
                                                        <div class="bead current"><span>1</span></div>
                                                        Add Prom Event
                                                    </header>
                                                </section>
                                                <section class="section2">
                                                    <header>
                                                        <div class="bead"><span>2</span></div>
                                                        Add Measured
                                                    </header>
                                                </section>
                                                <section>
                                                    <header>
                                                        <div class="bead"><span>3</span></div>
                                                        Add Comment
                                                    </header>
                                                </section>

                                            </div>
                                            <div className="col-md-8">
                                                <h4>Add Prom Event</h4>
                                                <div className="inputCardBox mt-4">
                                                    <div className="row">
                                                        <div className="col-6 col-md-6 mb-3">
                                                            <label>Event date  <span className="text-red-500">*</span></label>
                                                            <input class="" type="date" placeholder="Enter date" />
                                                        </div>
                                                        <div className="col-6 col-md-6 mb-3">
                                                            <label>School name  <span className="text-red-500">*</span></label>
                                                            <input class="" type="text" placeholder="Enter name" />
                                                        </div>
                                                        <div className="col-6 col-md-6 mb-3">
                                                            <label>First name  <span className="text-red-500">*</span></label>
                                                            <input class="" type="text" placeholder="Enter name" />
                                                        </div>
                                                        <div className="col-6 col-md-6 mb-3">
                                                            <label>Last name  <span className="text-red-500">*</span></label>
                                                            <input class="" type="text" placeholder="Enter name" />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label>Address  <span className="text-red-500">*</span></label>
                                                            <input class="" type="text" placeholder="Enter address" />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label>State  <span className="text-red-500">*</span></label>
                                                            <select>
                                                                <option>Select state</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-6 col-md-6 mb-3">
                                                            <label>City  <span className="text-red-500">*</span></label>
                                                            <input class="" type="text" placeholder="Enter city" />
                                                        </div>
                                                        <div className="col-6 col-md-6 mb-3">
                                                            <label>Zip Code <span className="text-red-500">*</span></label>
                                                            <input class="" type="text" placeholder="Enter zipcode" />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label>Phone Number <span className="text-red-500">*</span></label>
                                                            <input class="" type="text" placeholder="Enter Phone Number" />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label>Email Address <span className="text-red-500">*</span></label>
                                                            <input class="" type="text" placeholder="Enter E-mail" />
                                                        </div>
                                                        <div className="row  mt-3 mpadd">
                                                            <div className="col-md-5 mb-2 mpadd">
                                                                <div className="custom-control custom-control-sm custom-switch">
                                                                    <input type="checkbox" className="custom-control-input" id="customSwitch7" />
                                                                    <label className="custom-control-label" htmlFor="customSwitch7"> Alternate Pickup Location</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-5 mb-2 mpadd">
                                                                <div className="custom-control custom-control-sm custom-switch">
                                                                    <input type="checkbox" className="custom-control-input"
                                                                        id="customSwitch8" />
                                                                    <label className="custom-control-label" htmlFor="customSwitch8" data-bs-toggle="modal" data-bs-target="#dropShipping"> Drop Shipping</label>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-6 mpadd">
                                                                <label>Affiliated store</label>
                                                                <select class="">
                                                                    <option>Roberts Menswear</option>
                                                                </select>
                                                            </div>
                                                            <div class="col-md-12 mt-3 mpadd">
                                                                <div class="affiliateBox">
                                                                    <p class="mb-1 text-dark">Affiliated store <small> #07 </small></p>
                                                                    <ul>
                                                                        <li><em class="icon ni ni-user-alt"></em> Roberts Menswear</li>
                                                                        <li><em class="icon ni ni-map-pin"></em> 1226 University Drive, Menio Park CA 94025 United Stated</li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12 mt-3">
                                                            <button type="submit" class="addBtnCustomer">Continue</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" tabindex="-1" id="dropShipping">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Drop Shipping</h5>
                            <a href="#" class="close" data-bs-dismiss="modal" aria-label="Close"><em class="icon ni ni-cross-c"></em></a>
                        </div>
                        <div class="modal-body inputCardBox">
                            <div class="row">
                                <div className="col-md-12 mb-2">
                                    <h6 className="instructionHeading">Drop shipment are charged all shipping costs, plus a $6 fee per address per week. RS labels
                                        are include inside each box unless otherwise requested. When drop-shipping multiple tickets
                                        to the same person/address, select the already created dropship number in the list below.
                                    </h6>
                                </div>
                                <div class="col-md-12 mb-3 mt-3">
                                    <label>Name</label>
                                    <input type="text" class="" placeholder="Enter full name" />
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label>Address line 1</label>
                                    <input type="text" class="" placeholder="Enter Address line 1" />
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label>Address line 2</label>
                                    <input type="text" class="" placeholder="Enter Address line 2" />
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>City</label>
                                    <input type="text" class="" placeholder="Enter City" />
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>State</label>
                                    <select class="">
                                        <option>Select State</option>
                                    </select>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>Zip Code</label>
                                    <input type="text" class="" placeholder="Enter Zip Code" />
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>Phone</label>
                                    <input type="text" class="" placeholder="Enter phone number" />
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-4 mb-3">
                                    <button type="submit" class="addBtnCustomer">Add Ship</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Container>
    )
}

export default AddPromOrder